import { defineMessages } from 'react-intl';

export default defineMessages({
  stepUpSsoHeader: {
    id: 'stepUp.sso.header',
    defaultMessage: 'Verify your identity',
  },
  stepUpSsoReturnToLogin: {
    id: 'stepUp.sso.return.to.login',
    defaultMessage: 'Need to log in to a different account?',
  },
  stepUpSsoDescription1: {
    id: 'stepUp.sso.description1',
    defaultMessage:
      'To access this content, you need to log in with single sign-on and verify your identity.',
  },
  stepUpSsoDescription2: {
    id: 'stepUp.sso.description2',
    defaultMessage: 'If you’re unable to log in, contact the admin.',
  },
  stepUpSsoVerifyButton: {
    id: 'stepUp.sso.button.verify',
    defaultMessage: 'Verify',
  },
  stepUpSsoWarningModalHeader: {
    id: 'stepUp.sso.warning.modal.header',
    defaultMessage: 'Log in to verify identity',
  },
  stepUpSsoWarningModalDescription1: {
    id: 'stepUp.sso.warning.modal.description',
    defaultMessage: 'You’re about to leave Atlassian with this external link {idpRedirectLocation}',
  },
  stepUpSsoWarningModalDescription2: {
    id: 'stepUp.sso.warning.modal.description2',
    defaultMessage: 'If you trust the link, then continue to log in with single sign-on.',
  },
  stepUpSsoWarningLogInButton: {
    id: 'stepUp.sso.warning.log.in.button',
    defaultMessage: 'Log in',
  },
  stepUpWarningCancelButton: {
    id: 'stepUp.warning.cancel.button',
    defaultMessage: 'Cancel',
  },
});
